import { render, staticRenderFns } from "./InstallDescAndroid.vue?vue&type=template&id=7e9faf18&scoped=true"
import script from "./InstallDescAndroid.vue?vue&type=script&lang=js"
export * from "./InstallDescAndroid.vue?vue&type=script&lang=js"
import style0 from "./InstallDescAndroid.vue?vue&type=style&index=0&id=7e9faf18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9faf18",
  null
  
)

export default component.exports